<template>
  <div class="top">
    <div style="margin: 20px 0 20px 0; padding:20px 20px 20px 20px; background-color: white" >
      <el-upload
          class="upload-demo" action="" :on-change="handleChange" :on-remove="handleRemove" :on-exceed="handleExceed" :limit=1
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :auto-upload="false">
        <el-button type="danger">上传Excel<i class="el-icon-upload el-icon--right"></i></el-button>
      </el-upload>
      <div style="text-align:left">
        <el-button type="primary" plain @click="batchAddRecord" v-if="isShow">批量添加手动对冲记录</el-button>
      </div>
      <el-table :data="importData" border style="width: 100%" v-if="isShow" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
<!--        <el-table-column prop="index" label="序号" sortable></el-table-column>-->
        <el-table-column prop="" label="对冲产品" sortable>
          <template slot-scope="scope">
            <el-select :value="scope.row.hedgeProductType"  @change="updateValue(scope.row,'hedgeProductType',$event)">
              <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="" label="对冲目标类型" sortable>
          <template slot-scope="scope">
            <el-select :value="scope.row.hedgeTargetType"  @change="updateValue(scope.row,'hedgeTargetType',$event)">
              <el-option v-if="scope.row.hedgeProductType === 'SPOT'"  v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
              <el-option v-if="scope.row.hedgeProductType === 'SUPER_CONTRACT'"  v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="" label="对冲目标值" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.hedgeTargetValue"  @change="updateValue(scope.row,'hedgeTargetValue',$event)"/>
          </template>
        </el-table-column>
        <el-table-column prop="" label="交易对" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.pair"  @change="updateValue(scope.row,'pair',$event)"/>
          </template>
        </el-table-column>
        <el-table-column prop="" label="对冲账号" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.exchange"  @change="updateValue(scope.row,'exchange',$event)"/>
          </template>
        </el-table-column>
        <el-table-column label="外部订单编号" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.externalOrderId"  @change="updateValue(scope.row,'externalOrderId',$event)"/>
          </template>
        </el-table-column>
        <el-table-column prop="" label="外部委托方向" sortable>
          <template slot-scope="scope">
            <el-select :value="scope.row.externalOrderDirection" @change="updateValue(scope.row,'externalOrderDirection',$event)">
              <el-option v-for="item in externalOrderDirectionEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="" label="委托成交量" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.dealBaseAmt"  type="number" @change="updateValue(scope.row,'dealBaseAmt',$event)"/>
          </template>
        </el-table-column>
        <el-table-column prop="" label="委托成交金额" sortable>
          <template slot-scope="scope">
            <el-input :value="scope.row.dealQuotaAmt"  type="number" @change="updateValue(scope.row,'dealQuotaAmt',$event)"/>
          </template>
        </el-table-column>
        <el-table-column prop="startHedgeTime" label="开始对冲时间" sortable></el-table-column>
        <el-table-column prop="exchangeTime" label="交易所时间" sortable></el-table-column>
        <el-table-column prop="remark" label="备注" sortable></el-table-column>
        <el-table-column prop="joinProfitLoss" label="是否参加盈亏" sortable></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="submit(scope.row)">添加</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="批量添加结果" sortable>
          <template slot-scope="scope">
            <el-button size="small" :value="scope.row.status" type="success" v-if="scope.row.status === 'SUCCESS'" disabled>{{ scope.row.status }}</el-button>
            <el-button size="small" :value="scope.row.status" type="danger" v-if="scope.row.status === 'FAILURE'" disabled>{{ scope.row.status }}</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="block">
      <el-form :model="strategyData" label-width="150px" :label-position="'right'">
        <el-form-item label="对冲产品">
          <el-select v-model="strategyData.hedgeProductType" placeholder="请选择对冲产品" style="width: 250px">
            <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标类型">
          <el-select v-model="strategyData.hedgeTargetType" placeholder="请选择对冲产品" style="width: 250px">
            <el-option v-if="strategyData.hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
            <el-option v-if="strategyData.hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标值">
          <el-input v-model="strategyData.hedgeTargetValue" placeholder="请输入对冲目标值" required="required" clearable style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="交易对">
          <el-autocomplete v-model="strategyData.pair" :fetch-suggestions="querySearchAsync" @change="findOne" required="required" clearable style="width: 250px"></el-autocomplete>
        </el-form-item>
<!--        <el-form-item label="交易对">-->
<!--          <el-input v-model="strategyData.pair" placeholder="请输入交易对" required="required" clearable style="width: 250px"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="交易账号">
          <el-radio-group v-model="strategyData.exchange">
            <el-radio v-for="exchange in hedgeAccountEnum" :label="exchange.key" border style="width: 180px" size="small"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="外部订单编号">
          <el-input v-model="strategyData.externalOrderId" placeholder="请输入外部订单编号" clearable style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="外部委托方向">
          <el-select v-model="strategyData.externalOrderDirection" placeholder="请选择外部委托方向" style="width: 250px">
            <el-option v-for="item in externalOrderDirectionEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="委托成交量">
          <el-input v-model="strategyData.dealBaseAmt" placeholder="请输入委托成交量" type="number" required="required" step="0.001" clearable style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="委托成交金额">
          <el-input v-model="strategyData.dealQuotaAmt" placeholder="请输入委托成交金额" type="number" required="required" step="0.01" clearable style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="差额">
          <el-input v-model="strategyData.financeDifference" placeholder="请输入差额" type="number" required="required" step="0.01" clearable style="width: 250px"></el-input>
        </el-form-item>

        <el-form-item label="开始对冲时间">
          <el-date-picker
              v-model="strategyData.startHedgeTime"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions" style="width: 250px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="交易所时间">
          <el-date-picker
              v-model="strategyData.exchangeTime"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions" style="width: 250px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="strategyData.remark" clearable style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="是否参加盈亏">
          <el-switch
              v-model="strategyData.joinProfitLoss"
              active-text="开"
              inactive-text="关">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addManualStrategy">立即创建</el-button>
          <el-button @click="clearData">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import './store'
import utils from './utils'
import '@/entries/Machine/cache'
import {mapActions, mapState} from "vuex";

const externalOrderDirectionOptions = [{key:'BID', label:'买'}, {key:'ASK', label:'卖'}]
const hedgeTargetTypeEnum_SPOT_Op = [
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeEnum_SUPER_CONTRACT_Op = [
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const exchangeOptions = ["BINANCE","HUOBI","GATEIO","OKEX","FTX","COINEX","ZB","MXC","HBTC","INTERNAL"]
const pickerOptions = {shortcuts: [
    {text: '今天', onClick(picker) {picker.$emit('pick', new Date());}},
    {text: '昨天', onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24);picker.$emit('pick', date);}},
    {text: '前天', onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);picker.$emit('pick', date);}},
    {text: '一周前', onClick(picker) {const date = new Date();date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);picker.$emit('pick', date);}}]
}

export default {
  name: "ManualRecords",
  data() {
    return {
      fileTemp:'',
      isShow:false,
      importData:[],
      accountData:[],
      multipleSelection: [],
      dialogVisible: false,
      localCache:{},
      strategyData: {
        hedgeTargetType:'',
        hedgeTargetValue:'',
        exchange:'',
        externalOrderId:'',
        pair:'',
        externalOrderDirection: '',
        dealBaseAmt:'',
        dealQuotaAmt: '',
        startHedgeTime:'',
        exchangeTime:'',
        remark:'',
        joinProfitLoss: true,
        financeDifference:''
      },
      exchanges:[],
      pickerOptions:pickerOptions,
      externalOrderDirectionEnum:externalOrderDirectionOptions,
      hedgeTargetTypeEnum_SPOT: hedgeTargetTypeEnum_SPOT_Op,
      hedgeTargetTypeEnum_SUPER_CONTRACT: hedgeTargetTypeEnum_SUPER_CONTRACT_Op,
    }
  },
  computed:{
    ...mapState('newHedgeStore', ['hedgeAccountEnum', 'hedgeProductTypeOptions']),
    ...mapState('quotationCache', ['configurations']),
  },
  watch:{
    'strategyData.dealBaseAmt'(val){

    }
  },
  created() {
    this.strategyData.hedgeProductType = this.hedgeProductTypeOptions[0].key
    this.queryConfigurations()
  },
  methods: {
    ...mapActions('quotationCache', ['queryConfigurations']),
    createStateFilter(queryString) {
      return (state) => {
        return (state.pair.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    querySearchAsync(queryString, cb) {
      let restaurants = this.configurations;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].pair});
      }
      cb(suggest);
    },

    findOne() {
      let len = this.configurations.length;
      this.configuration = {};
      for (let i = 0; i < len; i++) {
        if (this.pair === this.configurations[i].pair) {
          this.configuration = this.deepCopy(this.configurations[i]);
          return;
        }
      }
    },

    addManualStrategy(){
      if (!this.strategyData.hedgeTargetValue){
        this.$message.error("请输入对冲目标值")
        return
      }
      if (!this.strategyData.pair){
        this.$message.error("请输入交易对")
        return
      }
      if (!this.strategyData.exchange){
        this.$message.error("请勾选交易所")
        return
      }
      if (!this.strategyData.externalOrderDirection){
        this.$message.error("请选择外部委托方向")
      }

      if (!this.strategyData.dealQuotaAmt){
        this.$message.error("请输入委托成交量")
        return
      }
      if (!this.strategyData.startHedgeTime){
        this.$message.error("请选择日期")
        return
      }
      if (!this.strategyData.exchangeTime){
        this.$message.error("请输入交易所时间")
        return
      }
      this.strategyData.startHedgeTime = new Date(this.strategyData.startHedgeTime).getTime()
      this.strategyData.exchangeTime = new Date(this.strategyData.exchangeTime).getTime()
      if (this.diff(this.localCache, this.strategyData)){
        this.$message.error("已添加记录不可重复提交")
        return;
      } else {
        this.localCache = this.deepCopy(this.strategyData)
      }
      utils.addManualHedgeRecord(this.strategyData).then((response)=>{
        if(response.data === true){
          this.$message.success("添加手动对冲记录成功")
        }else{
          this.$message.error("添加手动对冲记录失败")
        }
      })
    },

    diff(obj1, obj2){
      let o1 = obj1 instanceof Object;
      let o2 = obj2 instanceof Object;
      if(!o1 || !o2){
        return obj1 === obj2;
      }
      if(Object.keys(obj1).length !== Object.keys(obj2).length){
        return false;
      }
      for(let attr in obj1){
        let t1 = obj1[attr] instanceof Object;
        let t2 = obj2[attr] instanceof Object;
        if(t1 && t2){
          return this.diff(obj1[attr],obj2[attr]);
        }else if(obj1[attr] !== obj2[attr]){
          return false;
        }
      }
      return true;
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    clearData() {
      this.strategyData = {
        hedgeProductType: '',
        hedgeTargetType:'',
        hedgeTargetValue:'',
        exchange:'',
        externalOrderId:'',
        pair:'',
        externalOrderDirection: '',
        dealBaseAmt:'',
        dealQuotaAmt: '',
        startHedgeTime:'',
        exchangeTime:'',
        remark:'',
        joinProfitLoss: true,
        financeDifference:''
      }
    },

    updateValue(data, name, val){
      data[name] = val
    },

    handleChange(file, fileList){
      this.fileTemp = file.raw;
      if(this.fileTemp){
        if((this.fileTemp.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type === 'application/vnd.ms-excel')){
          this.excelHandler(this.fileTemp);
        } else {this.$message.error('附件格式错误，请删除后重新上传')}
      } else {this.$message.info('请上传附件')}
    },

    handleExceed(){
      this.$message.warning('超出最大上传文件数量的限制')
    },

    handleRemove(file,fileList){
      this.fileTemp = ''
      this.importData = []
      this.isShow = false
    },

    excelHandler(obj) {
      let _this = this;
      this.file = event.currentTarget.files[0];
      let rABS = false; //是否将文件读取为二进制字符串
      let f = this.file;
      let reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function(f) {
        let binary = "";
        let rABS = false; //是否将文件读取为二进制字符串
        let wb;
        let outData;
        let reader = new FileReader();
        reader.onload = function(e) {
          let bytes = new Uint8Array(reader.result);
          let length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {type: "base64"});
          } else {
            wb = XLSX.read(binary, {type: "binary"});
          }
          outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          let buffer = [];
          let index = 0
          outData.map(v => {
            v.index = index
            v.status = ''
            buffer.push(v)
            index = index + 1
          });
          _this.importData = buffer
          _this.isShow = true
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {reader.readAsArrayBuffer(f);} else {reader.readAsBinaryString(f);}
    },

    async submit(requestData){
      let tableData = this.importData
      requestData.startHedgeTime = new Date(requestData.startHedgeTime).getTime()
      requestData.exchangeTime = new Date(requestData.exchangeTime).getTime()
      if(!requestData.hasOwnProperty("externalOrderId")){
        requestData['externalOrderId'] = ''
      }
      try {
        await utils.addManualHedgeRecord(requestData).then((response)=>{
          if(response.data === true){
            this.$message.success("添加成功")
            tableData[requestData.index]['status'] = 'SUCCESS'
          }else{
            this.$message.error("添加失败")
            tableData[requestData.index]['status'] = 'FAILURE'
          }
        })
      } catch (err){
        tableData[requestData.index]['status'] = 'FAILURE'
      }
      this.importData = tableData
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    async batchAddRecord(){
      let tableData = []
      for (let i in this.multipleSelection){
        this.multipleSelection[i].startHedgeTime = new Date(this.multipleSelection[i].startHedgeTime).getTime()
        this.multipleSelection[i].exchangeTime = new Date(this.multipleSelection[i].exchangeTime).getTime()
        if(!this.multipleSelection[i].hasOwnProperty("externalOrderId")){
          this.multipleSelection[i]['externalOrderId'] = ''
        }
        try {
          await utils.addManualHedgeRecord(this.multipleSelection[i]).then((response=>{
            if (response.data === true){
              this.multipleSelection[i]['status'] = 'SUCCESS'
            }else{
              this.multipleSelection[i]['status'] = 'FAILURE'
            }
          }))
        } catch (e){
          this.multipleSelection[i]['status'] = 'FAILURE'
        }
        tableData.push(this.multipleSelection[i])
      }
      this.importData = tableData
    },
  },
}

</script>

<style scoped>
.top{
  margin: 15px 0 15px 0;
}
.block{
  margin: 20px 0 20px 0;
  padding: 30px 0 20px 0;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}

.el-checkbox+.el-checkbox {
  margin-right: 20px;
}

</style>
